import { BCMSRecord, BCMSRecordProperty } from "bcms-react";
import {NotificationCategory,NotificationDetail} from "model";

/**
 * @class Notification
 * @classdesc Class definition for record type from model
 * @param {OBJECT} record - record from the model to init class
 * @extends BCMSRecord
 * @example const notification = new Notification(model.notificationHistory[0]);
 * 
 * @property {NUMBER} _id - The id of the notification 
 * @property {STRING} _name - The name of the notification 
 * @property {STRING} _category - The category of the notification
* @property {BOOLEAN} _limited - true If the notification is shown for Notifi limited
* @property {BOOLEAN} _activated - true If the notification is shown for Notifi limited
*/
export default class Notification extends BCMSRecord {
    _id;
    _name;
    _limited;
    _category;
    _activated;
    _subscriptionRecentlyDeleted

    constructor(record) {
        super(record);
  
    }
  static SetActivated(notifications,details){
       return notifications.map((notification)=>{
       let details = NotificationDetail.getByNotificationID(notification.id)
       if(details.length > 0){
        notification.activated  =   details.filter(detail=>{
            return detail.isEnabled === true;
        }).length >0
       }
          return notification;
        })
        
    }
 
    /**
    * @function Limited
    * @instance
    * @param {OBJECT} model - The model object
    * @returns {Notification}
    * @description Returns All limited notifications
    * @memberof Notification
    */
 static Limited(notifications){
    const useNotifications = notifications ?? Notification.initAll();
    return useNotifications.filter((notification)=>{
      return notification.limited === true;
    });
}
    /**
    * @function ByType
    * @instance
    * @param {OBJECT} model - The model object
    * @returns {Notification}
    * @description Returns All Notifications Sorted by ByType
    * @memberof Notification
    */
 static ByType(notifications){
    const useNotifications = notifications ?? Notification.initAll();
    return useNotifications.reduce((byType,notification)=>{
        if(byType[notification.type]){
            byType[notification.type].push(notification);
        }else{
            byType[notification.type] = [];
            byType[notification.type].push(notification);
        }
        return byType;
    },{});
}
    /**
    * @function ByCategory
    * @instance
    * @param {OBJECT} model - The model object
    * @returns {Notification}
    * @description Returns All Notifications Sorted by category
    * @memberof Notification
    */
     static ByCategory(notifications){
        const useNotifications = notifications ?? Notification.initAll();
        return useNotifications.reduce(function(byCategory,notification){
            if(byCategory[notification.category.name]){
                byCategory[notification.category.name].alerts.push(notification);
            }else{
                byCategory[notification.category.name] = {}
                byCategory[notification.category.name].alerts = [];
                byCategory[notification.category.name].alerts.push(notification);
                byCategory[notification.category.name].category = NotificationCategory.initByName(notification.category.name)
            }
            return byCategory
        },{});
    }
    /**
    * @function CategoryList
    * @instance
    * @param {OBJECT} model - The model object
    * @returns {Notification}
    * @description Returns All Notifications Sorted by category
    * @memberof Notification
    */
       static CategoryList(notifications){
        const useNotifications = notifications ?? Notification.initAll();
        return Object.keys(Notification.ByCategory(useNotifications));
    }

    /**
    * @function FilterOutByType
    * @instance
    * @param {OBJECT} model - The model object
    * @returns {Notification}
    * @description Returns all notifications that are not of the
    * "type" passed, such as all non "scheduled" notifications.
    * @memberof Notification
    */
    static FilterOutByType(notifications, type) {
        const useNotifications = notifications ?? Notification.initAll();
        return useNotifications.filter(notification => notification.type !== type);
    }
}
   

Notification.define({
    "recordType" : "notifications",
    "recordIDProp" : "id",
    "className" : "Notification",
    "recordProperties" : [
        /**
         * @name id
         * @instance
         * @property get {NUMBER} - gets the id of the notification 
         * @property set {NUMBER} - sets the id of the notification 
         * @memberof Notification
         */
        BCMSRecordProperty.mapToNumber("id", "_id"),

        /**
         * @name name
         * @instance
         * @property get {STRING} - gets the name of the notification 
         * @property set {STRING} - sets the name of the notification 
         * @memberof Notification
         */
        BCMSRecordProperty.mapToString("name", "_name"),

        /**
         * @name category
         * @instance
         * @property get {STRING} - gets the category of the notification 
         * @property set {STRING} - sets the category of the notification
         */
        BCMSRecordProperty.mapToClass("category", "_category", () => NotificationCategory),
         /**
         * @name type
         * @instance
         * @property get {STRING} - gets the type of the notification 
         * @property set {STRING} - sets the type of the notification
         */
           BCMSRecordProperty.mapToString("type", "_type"),
        /**
         * @name limited
         * @instance
         * @property get {BOOLEAN} - gets the limited of the notification
         * @property set {BOOLEAN} - sets the limited of the notification 
         * @memberof Notification
         */
          BCMSRecordProperty.mapToBoolean("limited", "_limited"),

        /**
         * @name activated
         * @instance
         * @property get {BOOLEAN} - gets the activated of the notification
         * @property set {BOOLEAN} - sets the activated of the notification 
         * @memberof Notification
         */
        BCMSRecordProperty.mapToBoolean("activated", "_activated"),

        /**
         * @name subscriptionRecentlyDeleted
         * @instance
         * @property get {BOOLEAN} - gets the subscriptionRecentlyDeleted value of the notification
         * @property set {BOOLEAN} - sets the subscriptionRecentlyDeleted value of the notification 
         * @memberof Notification
         */
        BCMSRecordProperty.mapToBoolean("subscriptionRecentlyDeleted", "_subscriptionRecentlyDeleted")
        
    ]
        
});